var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextractifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 9C8.25 8.58579 8.58579 8.25 9 8.25H15C15.4142 8.25 15.75 8.58579 15.75 9C15.75 9.41421 15.4142 9.75 15 9.75H12.75V15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V9.75H9C8.58579 9.75 8.25 9.41421 8.25 9Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 22C5.10457 22 6 21.1046 6 20C6 18.8954 5.10457 18 4 18C2.89543 18 2 18.8954 2 20C2 21.1046 2.89543 22 4 22Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 4C22 5.10457 21.1046 6 20 6C18.8954 6 18 5.10457 18 4C18 2.89543 18.8954 2 20 2C21.1046 2 22 2.89543 22 4Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18C18.8954 18 18 18.8954 18 20C18 21.1046 18.8954 22 20 22Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5.85462C4.51839 5.94837 4.26523 6 4 6C3.73477 6 3.48161 5.94837 3.25 5.85462V18.1454C3.48161 18.0516 3.73477 18 4 18C4.26523 18 4.51839 18.0516 4.75 18.1454V5.85462Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85462 4.75H18.1454C18.0516 4.51839 18 4.26523 18 4C18 3.73477 18.0516 3.48161 18.1454 3.25H5.85462C5.94837 3.48161 6 3.73477 6 4C6 4.26523 5.94837 4.51839 5.85462 4.75Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 5.85462C19.4816 5.94837 19.7348 6 20 6C20.2652 6 20.5184 5.94837 20.75 5.85462V18.1454C20.5184 18.0516 20.2652 18 20 18C19.7348 18 19.4816 18.0516 19.25 18.1454V5.85462Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1454 19.25H5.85462C5.94837 19.4816 6 19.7348 6 20C6 20.2652 5.94837 20.5184 5.85462 20.75H18.1454C18.0516 20.5184 18 20.2652 18 20C18 19.7348 18.0516 19.4816 18.1454 19.25Z",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextractifyIcon);
export default __webpack_public_path__ + "static/media/textractifyIcon.a929f06d69a527f7a458f5537a80ecd7.svg";
export { ForwardRef as ReactComponent };